import React from "react";
import {Box, Columns, Form, Heading, Table} from "react-bulma-components";
import InspectionRow from "./InspectionRow";
import {formatDate, readableDate} from "../../utils";


export default function InspectionFormSection({rental, vehicle, onChange}){

    const getRecommended15KDate = () => {
        if(rental && rental.mileage_allowance > 0) {
            let dailyMileage = rental.mileage_allowance / 365; // for this case it is safe to assume leap years do not exist
            // NOT NEEDED
            // How far through the current 15k set are we
            // let currentMileageProgress = rental.start_mileage - (Math.floor(rental.start_mileage / 15000) * 15000);
            // let daysTillNext = Math.ceil((15000 - currentMileageProgress) / dailyMileage);

            //change to just use 15k
            let daysTillNext = Math.ceil(15000 / dailyMileage);
            let start_date = new Date(rental.on_hire_date);
            start_date.setDate(start_date.getDate() + daysTillNext);
            return start_date;
        }
        else{
            return new Date();
        }
    }

    return (
        <Box>
            <Columns>
                <Columns.Column>
                    <Heading>Inspections</Heading>
                </Columns.Column>
            </Columns>
            <Columns>
                <Columns.Column>
                    <Table>
                        <thead>
                            <tr>
                                <th>Inspection Type</th>
                                <th>Expiry Date</th>
                            </tr>
                        </thead>
                        <tbody>
                        {vehicle.inspections.map((inspection, index) => (
                            <InspectionRow
                                data={inspection}
                                index={index}
                                onChange={onChange}
                            />
                        ))}
                        </tbody>
                    </Table>
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Recommended Next Date for 15K</Form.Label>
                    <p>{readableDate(formatDate(getRecommended15KDate()))}</p>
                </Columns.Column>
            </Columns>
        </Box>
    )

}